import './ConnectivityStatus.css';

import React, { type FC } from 'react';

import { WifiConnectionStatus, RemoteAccessStatus } from '@src/components';
import { useUnmountReactAndNavigate } from '@src/hooks';
import { Pages } from '@src/Pages';

export const ConnectivityStatus: FC = () => {
  const navigate = useUnmountReactAndNavigate();

  return (
    <div id="connectivity_status">
      <RemoteAccessStatus />
      <WifiConnectionStatus onClick={() => { navigate({ pathname: Pages.NETWORK_CONFIG, search: '?selectPage=wifi' }); }}/>
    </div>
  );
};
